import { useQuery } from '@tanstack/react-query';
import { queryFn } from './watchlistsQueryFn';
import useUser from '../useUser';

export const QUERY_KEY = ['WATCHLISTS'] as const;

export function useWatchlists() {
  const { data: user } = useUser();
  const query = useQuery({
    queryKey: QUERY_KEY,
    queryFn,
    staleTime: 3600000,
    retry: 1,
    enabled: user.loggedIn,
    meta: {
      tags: ['watchlist'],
    },
  });

  return query;
}
